import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";
import es from "./es.json";
import ar from "./ar.json";
import { LOCALES, applyDocumentLocale, toLocale, type Locale } from "@/lib/locale";

export const supportedLanguages = LOCALES;
export type SupportedLanguage = Locale;

export function normalizeLanguage(value?: string | null): SupportedLanguage | null {
  if (!value) return null;
  const normalized = value.toLowerCase().split(/[-_]/)[0];
  return (supportedLanguages as readonly string[]).includes(normalized) ? (normalized as SupportedLanguage) : null;
}

function initialLanguage(): SupportedLanguage {
  const stored = normalizeLanguage(localStorage.getItem("ui_language"));
  if (stored) return stored;

  // Browser language first, then the ordered preference list.
  const browserLanguage = normalizeLanguage(navigator.language);
  if (browserLanguage) return browserLanguage;

  const browserMatch = navigator.languages?.map(normalizeLanguage).find(Boolean);
  return browserMatch ?? "fr";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    fr: { translation: fr },
    es: { translation: es },
    ar: { translation: ar },
  },
  lng: initialLanguage(),
  // Spanish and Arabic are machine-translated from English, so a key that is
  // missing there resolves to English before French.
  fallbackLng: { es: ["en", "fr"], ar: ["en", "fr"], en: ["fr"], default: ["fr"] },
  interpolation: { escapeValue: false },
});

applyDocumentLocale(toLocale(i18n.language));
i18n.on("languageChanged", (lng) => applyDocumentLocale(toLocale(lng)));

export default i18n;
